import axios from "axios";

export class HttpClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }
  async axios(url, options) {
    return await axios(`${this.baseURL}${url}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }).then((res) => {
      if (res.status > 299 || res.status < 200) {
        const message =
          res && res.message ? res.message : "something went wrong!";
        const error = new Error(message);
        if (res.status === 400) {
          return error;
        }
        throw error;
      } else {
        return res;
      }
    });
  }
}
export class AdsNetworkHttpClient {
  constructor(adsNetworkUrl, authErrorEventBus) {
    this.adsNetworkUrl = adsNetworkUrl;
    this.authErrorEventBus = authErrorEventBus;
  }
  async axios(url, options) {
    let data;
    await axios(`${this.adsNetworkUrl}${url}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }).then((res) => {
      data = res;

      if (res.status > 299 || res.status < 200) {
        const message =
          data && data.message ? data.message : "something went wrong!";
        const error = new Error(message);
        if (res.status === 400) {
          this.authErrorEventBus.notify(error);
          return;
        }
        throw error;
      }
    });

    return data;
  }
}

export class AppInfoHttpClient {
  constructor(appInfoUrl, authErrorEventBus) {
    this.appInfoUrl = appInfoUrl;
    this.authErrorEventBus = authErrorEventBus;
  }
  async axios(url, options) {
    let data;
    await axios(`${this.appInfoUrl}${url}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }).then((res) => {
      data = res;

      if (res.status > 299 || res.status < 200) {
        const message =
          data && data.message ? data.message : "something went wrong!";
        const error = new Error(message);
        if (res.status === 400) {
          this.authErrorEventBus.notify(error);
          return;
        }
        throw error;
      }
    });
    return data;
  }
}
